<template>
    <div class="banner_wrap">
        <div class="m_banner">
            <div class="ban_l"></div>
            <swiper ref="mySwiper" :options="swiperOptions" class="main_swiper">
                <swiper-slide v-for="(banner, index) in bannerList" :key="`banner${banner.b_idx}`">
                    <div class="slide_pic">
                        <!--                    <a :href="`https://${banner.b_url}`" target="_blank"><img :src="`${returnBannerImage(banner)}`"></a>-->
                        <a>

                            <img :src="`${returnBannerImage(banner)}`" @click="openUrl(banner.b_url)">
                        </a>
                        <!--                    <img src="http://sunstat.com/wp-content/uploads/2019/01/%EC%8A%AC%EB%9D%BC%EC%9D%B4%EB%93%9C-%EB%B0%B0%EA%B2%BD%EC%9D%B4%EB%AF%B8%EC%A7%80.png">-->
                        <!-- <img :src="`${item.org_url}?${setImageOptions(185,185,'jpg')}`"
                              class="slide_img" alt="">
                         {{item.src}}-->
                    </div>
                </swiper-slide>

            </swiper>
            <div class="ban_r"></div>
            <div class="swiper-pagination" slot="pagination"></div>
        </div>

    </div>
</template>

<script>
    import imageOption from "@/mixins/imageOption";
    import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
    import 'swiper/swiper-bundle.css'
    import SwiperCore, {Pagination, Autoplay} from 'swiper';
    import 'swiper/components/pagination/pagination.scss';
    import util from "@/mixins/util";

    SwiperCore.use([Pagination, Autoplay]);
    export default {
        name: "BannerComponent",
        mixins: [imageOption],
        components: {
            Swiper,
            SwiperSlide
        },
        props: {},
        data() {
            return {
                bannerList: [],
                mentorList: [
                    {
                        src: ''
                    },
                    {
                        src: ''
                    },
                    {
                        src: ''
                    },
                ],
                swiperOptions: {
                    slidesPerView: 1,
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                },
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {
            this.getBanner()
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        directives: {
            swiper: directive
        },
        methods: {
            getBanner() {
                let params = {ip: 0}
                try {
                    this.$api.$banner.getBanner(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.type == 1) {
                            this.bannerList = res.List
                        }

                    })
                } catch (e) {
                    console.log(e)
                }
            },
            returnBannerImage(banner) {
                return banner.hasOwnProperty('Files') ? `${banner.Files[0].org_url}?${this.setImageOptions(1100, 461, 'png')}` : ''

            },
            openUrl(url) {
                if (!util.isEmpty(url)) {
                    if (url.includes('https://') || url.includes('http://')) {
                        window.open(url, '_blank')
                    }
                    window.open(`http://${url}`, '_blank')
                }
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>